import React from 'react'

const CardForm = () => {
  return (
    <form class="w-full">
      <div class="mb-3 grid grid-cols-2 gap-4">
        <div class="col-span-2 sm:col-span-1">
          <label for="full_name" class="mb-2 block text-sm font-medium text-gray-900 "> Full name (as displayed on card)* </label>
          <input type="text" id="full_name" class="w-full rounded-md border-0 outline-none shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5" placeholder="Bonnie Green" required />
          {/* <input type="text" id="full_name" class="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900" placeholder="Bonnie Green" required /> */}
        </div>

        <div class="col-span-2 sm:col-span-1">
          <label for="card-number-input" class="mb-2 block text-sm font-medium text-gray-900 "> Card number* </label>
          <input type="text" id="card-number-input" class="w-full rounded-md border-0 outline-none shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5" placeholder="xxxx-xxxx-xxxx-xxxx" pattern="^4[0-9]{12}(?:[0-9]{3})?$" required />
        </div>

        <div>
          <label for="card-expiration-input" class="mb-2 block text-sm font-medium text-gray-900 ">Card expiration* </label>
          <div class="relative h-10">


            <input datepicker-format="mm/yy" id="card-expiration-input" type="input" class="w-full rounded-md border-0 outline-none shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5" placeholder="12/23" required />
          </div>
        </div>
        <div>
          <label for="cvv-input" class="mb-2 flex items-center gap-1 text-sm font-medium text-gray-900 ">
            CVV*
            <button data-tooltip-target="cvv-desc" data-tooltip-trigger="hover" class="text-gray-400 hover:text-gray-900 dark:text-gray-500 dark:hover:text-white">
              <svg class="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fillRule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z" clipRule="evenodd" />
              </svg>
            </button>
            <div id="cvv-desc" role="tooltip" class="tooltip invisible absolute z-10 inline-block rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white opacity-0 shadow-sm transition-opacity duration-300 dark:bg-gray-700">
              The last 3 digits on back of card
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          </label>
          <input type="number" id="cvv-input" aria-describedby="helper-text-explanation" class="w-full rounded-md border-0 outline-none shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5" placeholder="•••" required />
        </div>
      </div>
    </form>
  )
}

export default CardForm